import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FormatCurrency, useCurrencyConstants } from './CurrencyFormatter';
import { amountDisplayPerPolicy, policyDisplay } from './CleanInputs';
import AutoBillingBadge from './AutoBillingBadge';

const PlanAmount = ({ itemInfo, currency, currencySymbol, currencyFormat }) => {
    const { t } = useTranslation('common');

    if ((itemInfo.policy === 'CUSTOM') && !itemInfo.cost) {
        return <span className="inv_amt_des">{t('amount_fixed')}</span>;
    }
    if (itemInfo.policy === 'TARGET') {
        return <span className="inv_amt_des">{t('products.target-fixed')}</span>;
    }
    if (itemInfo.policy === 'FLEXIBLE') {
        return <span className="inv_amt_des">{t('products.flexible-amount')}</span>;
    }
    if (itemInfo.policy === 'FIXED' && itemInfo.cost != null) {
        return (
            <FormatCurrency
                amount={itemInfo.cost}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
                className="planInfo"
            />
        );
    }

    return <span>{amountDisplayPerPolicy(currency, itemInfo)}</span>;
};

export const TreeSelectItemInfoContent = ({ itemInfo }) => {
    const { t } = useTranslation('common');
    const defMembership = useSelector((state) => state.defMembership.defMembership);
    const { currencySymbol, currencyFormat } = useCurrencyConstants();
    const currency = defMembership?.business?.currency;

    if (!itemInfo) return null;

    if (itemInfo.type === 'product') {
        return (
            <div className="planInfo-div pb-0">
                <span className="planName_title">{itemInfo.name}</span>
                {itemInfo.description ? (
                    <span className="planInfoDesc">{itemInfo.description}</span>
                ) : null}
                {itemInfo.exclusive ? (
                    <span className="tree-select-exclusive-tag">{t('product.exclusive')}</span>
                ) : (
                    <span className="tree-select-non-exclusive-tag">{t('product.non_exclusive')}</span>
                )}
            </div>
        );
    }

    return (
        <div className="planInfo-div pb-0">
            <span className="planName_title">{itemInfo.name}</span>
            <AutoBillingBadge collectionMode={itemInfo.collectionMode} />
            {itemInfo.description ? (
                <span className="planInfoDesc">{itemInfo.description}</span>
            ) : null}

            {itemInfo.policy ? (
                <div className="mb-1">{policyDisplay(itemInfo)}</div>
            ) : null}

            <div style={{ marginBottom: '0.5rem' }}>
                <div style={{ margin: '0rem 0.5rem 0rem 0rem' }}>
                    <PlanAmount
                        itemInfo={itemInfo}
                        currency={currency}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                    />
                </div>

                {itemInfo.billingPeriod ? (
                    <div className="mb-0.5">
                        <span className="planInfoBillingPeriod">
                            {t(`product.${itemInfo.billingPeriod.toLowerCase()}`)}
                        </span>
                    </div>
                ) : null}

                {itemInfo.deductions ? (
                    <div className="flex-direction">
                        <span className="num-payments">{itemInfo.deductions}</span>
                        <span className="num-payments">{t('common.payments')}</span>
                    </div>
                ) : null}
            </div>

            {itemInfo.setup ? (
                <div className="mb-1 flex-direction">
                    <span className="setup_plan_info_label">{t('product.setupFee')}</span>
                    <FormatCurrency
                        amount={itemInfo.setup}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                        className="setup_plan_info"
                    />
                </div>
            ) : null}

            {itemInfo.graceDays ? (
                <div className="mb-0.5 mt-1 flex-direction">
                    <span className="planInfo_label">{t('grace_period')}: </span>
                    <span className="planInfo_value">
                        {itemInfo.graceDays} {t('invitation.day')}
                    </span>
                </div>
            ) : null}

            {itemInfo.reminderDays ? (
                <div className="mb-0.5 flex-direction">
                    <span className="planInfo_label">{t('plan.reminder_label')}: </span>
                    <span className="planInfo_value">
                        {itemInfo.reminderDays} {t('invitation.day')}
                    </span>
                </div>
            ) : null}
        </div>
    );
};
